import axios from "axios";
import * as d3 from "d3";
import {
    colonAnnotation,
    fw_progressive_1way,
    fw_progressive_3way,
    make_x_gridlines,
    make_y_gridlines,
    numberFormat,
    responsivefy
} from '../functions'


export default function (chart, divId, vizName, filterParam, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    axios.post(url, filterParam).then(response => {
        let data = response.data

        data.forEach(function (d) {
            d.metric1 = +d.metric1;
            d.metric2 = +d.metric2;
            d.metric3 = +d.metric3;
        });

        var dataXAxis = d3.nest()
            .key(d => {
                return d.dim1_name;
            })
            .rollup(v => {
                return {
                    value1: d3.sum(v, function (d) {
                        return d.metric1;
                    }),
                    value2: d3.sum(v, function (d) {
                        return d.metric2;
                    }),
                    value3: d3.sum(v, function (d) {
                        return d.metric3;
                    })
                }
            })
            .entries(data);

        var expenseMetrics = d3.nest()
            .entries(dataXAxis)
            .map(function (group) {
                return {
                    key: group.key,
                    value1: group.value.value1,
                    value2: group.value.value2,
                    value3: group.value.value3,
                }
            });

        console.log(expenseMetrics, "New line");
        /* expenseMetrics.forEach(y => {
                    y.dim1_name = y.key;
                    y.values.forEach(d => {
                         d.metric1=+d.value1
                         d.metric2 = +d.value2;
                    });
                    y.values.sort((a, b) =>{ return b.metric1- a.metric1 });
             });*/

        // Set the x and y values
        var x1Scale = d3.scaleLinear().range([0, chart.width]);
        var y1Scale = d3.scaleLinear().range([chart.height, 0]);
        var y2Scale = d3.scaleLinear().range([chart.height, 0]);

        // Define the axes
        var x1AxisLabel = d3.axisBottom(x1Scale);

        var y1AxisLabel = d3.axisLeft(y1Scale).tickFormat(numberFormat);

        var y2AxisLabel = d3.axisRight(y2Scale).tickFormat(numberFormat);

        // Define the line
        var dataline = d3.line()
            .x(function (d) {
                return x1Scale(d.metric1);
            })
            .y(function (d) {
                return y1Scale(d.metric2);
            });

        var dataline2 = d3.line()
            .x(function (d) {
                return x1Scale(d.metric1);
            })
            .y(function (d) {
                return y2Scale(d.metric3);
            });

        var svg = d3.select(divId).select("svg").remove();
        // Adds the canvas
        svg = d3.select(divId)
            .append("svg")
            .attr("width", chart.width + 2 * chart.margin.left + chart.margin.right)
            .attr("height", chart.height + 5 * chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .attr("font", "Arial")
            .style("font-size", "14px")
            .append("g")
            .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

        // Nest the entries by symbol
        var dNest = d3.nest().key(function (d) {
            return d.dim1_name;
        }).entries(data);

        // set the colour scale
        var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way);
        var metric2ColorScale = d3.scaleOrdinal(fw_progressive_3way);
        //metric1ColorScale.domain(dNest);
        console.log(metric1ColorScale)
        // var tickVariant=Math.floor(d3.max(data,(d)=>d.metric1)/(chart.width/100)/10)*10
        var x1Scalemin = Math.floor(d3.min(data, (d) => {
            return d.metric1 / 200
        })) * 200
        // Scale the range of the data
        x1Scale.domain([x1Scalemin, d3.max(data, (d) => {
            return d.metric1;
        })]);
        y1Scale.domain(d3.extent(data, (d) => {
            return d.metric2;
        }));
        y2Scale.domain(d3.extent(data, (d) => {
            return d.metric3;
        }));

        // spacing for the legend
        var legendSpace = chart.width / dNest.length;

        console.warn(legendSpace)
        // Add the X Axis
        svg.append('g')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(x1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'end')
            .attr('dx', '-.8em')
            .attr('dy', '-.20em')
            .attr('transform', 'rotate(-60)')

        svg.append('text')
            .attr('x', (chart.width / 2))
            .attr('y', chart.height + chart.margin.bottom + 15 + chart.axisLabelDistance)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append('g')
            .call(y1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size', fontSize)

        svg.append("g")
            .attr("class", "y axis")
            .attr("transform", "translate(" + chart.width + " ,0)")
            .call(y2AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('x', 0 - (chart.height / 2))
            .attr('y', chart.width + chart.margin.right - 100)
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y2AxisDisplayName)
            .style('font-size', fontSize)

        // Loop through each symbol / key
        dNest.forEach(function (d) {
            var lines = svg.append("path")
                .attr("class", "line")
                .attr("fill", "none")
                .style("stroke", function () { // Add the colours dynamically
                    return d.metric1ColorScale = metric1ColorScale(d.key);
                })
                //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                .attr("stroke-width", 3)
                .attr("d", dataline(d.values))
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            console.warn(lines)

            var lines2 = svg.append("path")
                // .attr("class", "line")
                .attr('class', 'plotdashed')
                .attr("fill", "none")
                .style("stroke", function () { // Add the colours dynamically
                    return d.metric2ColorScale = metric2ColorScale(d.key);
                })
                //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                .attr("stroke-width", 3)
                .attr("d", dataline2(d.values))

            console.warn(lines2)

            // Add the dots for the tooltip

            d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
            var div = d3.select(divId).append('div').attr('class', 'tooltip')
                .attr('style', 'position: absolute; opacity: 0;')

            /*  d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
                 var y1tip = tooltip_class()

                 y1tip.attr('class', 'd3-tip'+divId.id)
                     .html((d)=> {
                         return chart.x1MetricTooltip+ colonAnnotation+ d.dim1_name+
                          "<br/>" +chart.x2MetricTooltip+ colonAnnotation+ numberFormat(d.metric1)+
                         "<br/>" +chart.y1MetricTooltip+ colonAnnotation+ numberFormat(d.metric2)
                     })

                 svg.call(y1tip);

                  var y2tip = tooltip_class()

                  y2tip.attr('class', 'd3-tip'+divId.id)
                      .html((d)=> {
                          return chart.x1MetricTooltip+ colonAnnotation+ d.dim1_name +
                          "<br/>" +chart.x2MetricTooltip+ colonAnnotation+ numberFormat(d.metric1) +
                           "<br/>" +chart.y2MetricTooltip+ colonAnnotation+ numberFormat(d.metric3)
                      })

                  svg.call(y2tip);*/

            svg.selectAll("dot")
                .data(data)
                .enter()
                .append("circle")
                .attr("r", 5)
                .attr("cx", function (d) {
                    return x1Scale(d.metric1);
                })
                .attr("cy", function (d) {
                    return y1Scale(d.metric2);
                })
                .style("fill", d => {
                    return metric1ColorScale(d.dim1_name)
                })
                //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                .on("mousemove", function (d) {
                    console.log(d3.event, d)
                    div.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div.html(chart.x1MetricTooltip + colonAnnotation + d.dim1_name + ' || ' + d.dim2_name +
                        "<br/>" + chart.x2MetricTooltip + colonAnnotation + numberFormat(d.metric1) +
                        "<br/>" + chart.y1MetricTooltip + colonAnnotation + numberFormat(d.metric2))
                        .style("left", (d3.event.layerX) + "px")
                        .style("top", (d3.event.layerY) + "px");
                })
                .on("mouseout", function () {
                    div.transition().style("opacity", 0)
                })
            //.on("mouseover", y1tip.show)
            //.on("mouseout", y1tip.hide)
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            svg.selectAll("dot")
                .data(data)
                .enter()
                .append("circle")
                .attr("r", 5)
                .attr("cx", function (d) {
                    return x1Scale(d.metric1);
                })
                .attr("cy", function (d) {
                    return y2Scale(d.metric3);
                })
                .style("fill", d => {
                    return metric2ColorScale(d.dim1_name)
                })
                // .attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
                .on("mousemove", function (d) {
                    console.log(d3.event, d)
                    div.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div.html(chart.x1MetricTooltip + colonAnnotation + d.dim1_name + ' || ' + d.dim2_name +
                        "<br/>" + chart.x2MetricTooltip + colonAnnotation + numberFormat(d.metric1) +
                        "<br/>" + chart.y2MetricTooltip + colonAnnotation + numberFormat(d.metric3))
                        .style("left", (d3.event.layerX) + "px")
                        .style("top", (d3.event.layerY) + "px");
                })
                .on("mouseout", function () {
                    div.transition().style("opacity", 0)
                })
            //.on("mouseover", y2tip.show)
            //.on("mouseout", y2tip.hide)
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
        });
        var y1legend = svg.append('g')
            .selectAll('g')
            .data(dataXAxis)
            .enter()
            .append('g')
            //.attr('transform', (d, i) => 'translate(0,' + i * 20 + ')')
            .attr('transform', function (d, i) {                     // NEW
                //  var height = 0;          // NEW
                var horz = 250 * i; // NEW
                var vert = 1;       // NEW
                return 'translate(' + horz + ',' + vert + ')';        // NEW
            });


        y1legend.append('line')
            .attr("x1", 0)
            .attr("x2", 30)
            .attr("y1", chart.height + 115)
            .attr("y2", chart.height + 115)
            .attr("stroke-width", 3)
            // .attr("stroke","black")
            // .attr("stroke-opacity", "3")
            .attr("class", "plotline")
            .attr('stroke', d => {
                return metric1ColorScale(d.key)
            })

        y1legend.append('text')
            .data(dataXAxis, (d) => {
                return d.key
            })
            .attr('x', 40)
            .attr('y', chart.height + 100)
            .attr('dy', '0.75em')
            .text((d) => {
                return chart.y1DataFieldName + d.key.substring(0, 5)
            })
            .style('font-size', "25px")

        var y2legend = svg.append('g')
            .selectAll('g')
            .data(dataXAxis)
            .enter()
            .append('g')
            //.attr('transform', (d, i) => 'translate(0,' + i * 20 + ')')
            .attr('transform', function (d, i) {                     // NEW
                //  var height = 0;          // NEW
                var horz = 250 * i; // NEW
                var vert = 25;       // NEW
                return 'translate(' + horz + ',' + vert + ')';        // NEW
            });

        y2legend.append('line')
            .attr("x1", 0)
            .attr("x2", 40)
            .attr("y1", chart.height + 140)
            .attr("y2", chart.height + 140)
            .attr("stroke-width", 3)
            // .attr("stroke","black")
            // .attr("stroke-opacity", "3")
            .attr("class", "plotdashed")
            .attr('stroke', d => {
                return metric2ColorScale(d.key)
            })


        y2legend.append('text')
            .data(dataXAxis, (d) => {
                return d.key
            })
            .attr('x', 40)
            .attr('y', chart.height + 120)
            .attr('dy', '0.75em')
            .text((d) => {
                return chart.y2DataFieldName + d.key.substring(0, 5)
            })
            .style('font-size', "25px")

        if (gridflag == true) {
            // add the X gridlines
            svg.append("g")
                .attr("class", "grid")
                .attr("transform", "translate(0," + chart.height + ")")
                .call(make_x_gridlines(x1Scale)
                    .tickSize(-chart.height)
                    .tickFormat(""))

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1Scale)
                    .tickSize(-chart.width)
                    .tickFormat(""))
        }

    });
}